import { connect } from 'react-redux';
import { Card, Dropdown } from 'react-bootstrap';
import PropertyPicker from './components/PropertyPicker';
import BaseFeature from './BaseFeature';
import PropertyDropdown from './components/PropertyDropdown';
import PropertyCheckbox from './components/PropertyCheckbox';
import { getHours, getHoursTD, getHoursTD60Hz, getHoursCD, getHoursCD60Hz } from '../../../../../../utils/constantValues';
import { DALI_DEXAL_SETTINGS, TOUCH_DIM_AND_SENSOR, CORRIDOR } from '../../../../../../utils/constantFeatures';
import DraggableAreaChart from './charts/DraggableAreaChart';
import { getErrorIssues } from '../../../../../../utils/validationSummary';
import { linearPercentage, logarithmicPercentage } from '../../../../../../utils/percentageUtility';
import { withTranslation } from 'react-i18next';

class Corridor extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            //isEnabledS2: this.isOn(this.props.properties[CORRIDOR.holdTime01]),
            isEnabledS2: this.props.properties[CORRIDOR.holdTime01].value !== 'Infinite',
            frequencySelected: this.props.properties[TOUCH_DIM_AND_SENSOR.mainsFrequency].value ? parseInt(this.props.properties[TOUCH_DIM_AND_SENSOR.mainsFrequency].value) : 50
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChartChange = this.handleChartChange.bind(this);
        this.handleChangeFrequency = this.handleChangeFrequency.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;

        if (this.getCorrectPropertyName(propertyName) === CORRIDOR.holdTime01) {
            this.setState({ isEnabledS2: value !== 'Infinite' });
        }

        if (propertyName.startsWith(DALI_DEXAL_SETTINGS.shortName)) {
            let property = this.props.extraProperties[propertyName];
            property.value = value;
            this.props.handleChangeExtraProperties(property);
        }
        else {
            this.props.handleChange(propertyName, v);
        }

    }

    handleChartChange() {
        this.setState({ properties: this.props.properties });
    }

    isOn(property) {
        return property.value !== undefined
            && property.value !== null
            && property.value !== 'Infinite'
            && property.value !== ''
            && property.value.toUpperCase() !== 'OFF'
            && property.value !== '0'
            && property.value !== property.valueMeta.off;
    }

    getPercentage(value, min, max) {
        const dimmingCurve = this.props.extraProperties[DALI_DEXAL_SETTINGS.dimmingCurve];

        if (dimmingCurve && dimmingCurve.value === '1') {
            return linearPercentage(value, min, max);
        }
        return logarithmicPercentage(value, min, max);
    }

    handleChangeFrequency(e) {
        const v = +e.target.name;
        this.setState({ frequencySelected: v });
        this.handleChange(TOUCH_DIM_AND_SENSOR.mainsFrequency, v);
    }

    renderStartupBehaviour() {
        const { t } = this.props;
        const startupBehaviour = this.props.properties[CORRIDOR.startupBehaviour];
        if (startupBehaviour) {
            return (
                <Card className="card-feature-component">
                    <div className="card-header-feature">
                        {t('Power_On_Behaviour')}
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        <PropertyDropdown
                            property={startupBehaviour}
                            properties={startupBehaviour.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                            propertyDisplayFunc={(res) => res}
                            title={''}
                            measureUnit={''}
                            handleChange={this.handleChange} />
                    </Card.Body>
                </Card>
            );
        }
        else return (null);
    }

    render() {
        const { t } = this.props;

        const fadeUpTime = this.props.properties[CORRIDOR.fadeUpTime];
        const operativeLevel = this.props.properties[CORRIDOR.operativeLevel];
        const holdTime00 = this.props.properties[CORRIDOR.holdTime00];
        const fadeDownTime = this.props.properties[CORRIDOR.fadeDownTime];
        const standbyLevel01 = this.props.properties[CORRIDOR.standbyLevel01];
        const holdTime01 = this.props.properties[CORRIDOR.holdTime01];
        const fadeDownTime12 = this.props.properties[CORRIDOR.fadeDownTime12];
        const standbyLevel02 = this.props.properties[CORRIDOR.standbyLevel02];
        const holdTime02 = this.props.properties[CORRIDOR.holdTime02];

        // const tdEsp = this.props.properties[TOUCH_DIM_AND_SENSOR.enableShortPush];
        // const tdElp = this.props.properties[TOUCH_DIM_AND_SENSOR.enableLongPush];
        // const tdEdp = this.props.properties[TOUCH_DIM_AND_SENSOR.enableDoublePush];

        const tdEsp = this.props.properties[TOUCH_DIM_AND_SENSOR.enableShortPush]
            ? this.props.properties[TOUCH_DIM_AND_SENSOR.enableShortPush]
            : this.props.properties[TOUCH_DIM_AND_SENSOR.enableShortPush1];
        const tdElp = this.props.properties[TOUCH_DIM_AND_SENSOR.enableLongPush]
            ? this.props.properties[TOUCH_DIM_AND_SENSOR.enableLongPush]
            : this.props.properties[TOUCH_DIM_AND_SENSOR.enableLongPush1];
        const tdEdp = this.props.properties[TOUCH_DIM_AND_SENSOR.enableDoublePush]
            ? this.props.properties[TOUCH_DIM_AND_SENSOR.enableDoublePush]
            : this.props.properties[TOUCH_DIM_AND_SENSOR.enableDoublePush1];

        let classNameS2 = 'card-feature-component';
        if (!this.state.isEnabledS2) {
            //classNameS2 += ' card-disabled';
            classNameS2 += ' card-none';
        }

        const lightControlComponent = tdEsp && tdElp && tdEdp
            ? (<Card className={this.getClassName([tdEsp, tdElp, tdEdp])}>
                <div className="card-header-feature">
                    {t('Light_Controls')}
                </div>
                <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                    <PropertyCheckbox
                        property={tdEsp}
                        title={t('Switch_ON_OFF_Short_Push')}
                        handleChange={this.handleChange} />
                    <PropertyCheckbox
                        property={tdElp}
                        title={t('Dim_UP_DOWN_Long_Push')}
                        handleChange={this.handleChange} />
                    <PropertyCheckbox
                        property={tdEdp}
                        title={t('Set_Reset_level_Double_Push')}
                        handleChange={this.handleChange} />
                </Card.Body>
            </Card>)
            : null;

        const dataChart = this.getDataChart(this.props.properties);
        return (
            <div className="flex-col">
                <div className="flex-row">
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {t('Mains_Frequency')}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <Dropdown>
                                <Dropdown.Toggle variant="secondary" disabled={this.props.disabled} className="edit-icon-project-header dropdown-osram">{this.state.frequencySelected}</Dropdown.Toggle>
                                <Dropdown.Menu style={{ minWidth: "auto", fontSize: "14px" }}>
                                    <Dropdown.Item onClick={this.handleChangeFrequency} name={50} key={50} >{50}</Dropdown.Item>
                                    <Dropdown.Item onClick={this.handleChangeFrequency} name={60} key={60} >{60}</Dropdown.Item>
                                </Dropdown.Menu>
                                Hz
                            </Dropdown>
                        </Card.Body>
                    </Card>

                    {this.renderStartupBehaviour()}

                    {lightControlComponent}

                    <Card className={this.getClassName([fadeUpTime, operativeLevel, holdTime00])}>
                        <div className="card-header-feature">
                            {t('Operative')}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyDropdown
                                property={fadeUpTime}
                                properties={fadeUpTime.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                propertyDisplayFunc={getHours}
                                title={t('Fade_Time_1')}
                                measureUnit={'mm:ss'}
                                handleChange={this.handleChange} />
                            <PropertyPicker
                                property={operativeLevel}
                                title={t('Operative_Level')}
                                measureUnit={this.getPercentage(operativeLevel.value, 1, 254)}
                                min={operativeLevel.valueMeta.min}
                                max={operativeLevel.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyDropdown
                                property={holdTime00}
                                properties={holdTime00.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                propertyDisplayFunc={this.state.frequencySelected === 50 ? getHoursTD : getHoursTD60Hz}
                                title={t('Hold_Time_2')}
                                measureUnit={'hh:mm:ss'}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                    <Card className={this.getClassName([fadeDownTime, standbyLevel01, holdTime01])}>
                        <div className="card-header-feature">
                            {t('StandBy_1')}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyDropdown
                                disabled={holdTime01.value === '0'}
                                property={fadeDownTime}
                                properties={fadeDownTime.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                propertyDisplayFunc={getHours}
                                title={t('Fade_Time_3')}
                                measureUnit={'mm:ss'}
                                handleChange={this.handleChange} />
                            <PropertyPicker
                                property={standbyLevel01}
                                title={t('DALI_Level')}
                                measureUnit={this.getPercentage(standbyLevel01.value, 1, 254)}
                                min={standbyLevel01.valueMeta.min}
                                max={standbyLevel01.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyDropdown
                                property={holdTime01}
                                properties={holdTime01.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                propertyDisplayFunc={this.state.frequencySelected === 50 ? getHoursCD : getHoursCD60Hz}
                                title={t('Hold_Time_4')}
                                measureUnit={'hh:mm:ss'}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>
                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={classNameS2 + " " + this.getClassName([fadeDownTime12, standbyLevel02, holdTime02])}>
                        <div className="card-header-feature">
                            {t('StandBy_2')}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyDropdown
                                disabled={holdTime02.value === '0'}
                                property={fadeDownTime12}
                                properties={fadeDownTime12.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                propertyDisplayFunc={getHours}
                                title={t('Fade_Time_5')}
                                measureUnit={'mm:ss'}
                                handleChange={this.handleChange} />
                            <PropertyPicker
                                property={standbyLevel02}
                                title={t('DALI_Level')}
                                measureUnit={this.getPercentage(standbyLevel02.value, 1, 254)}
                                min={standbyLevel02.valueMeta.min}
                                max={standbyLevel02.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyDropdown
                                property={holdTime02}
                                properties={holdTime02.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                propertyDisplayFunc={this.state.frequencySelected === 50 ? getHoursCD : getHoursCD60Hz}
                                title={t('Hold_Time_6')}
                                measureUnit={'hh:mm:ss'}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>
                <div className="flex-row">
                    <Card className="card-feature-component" style={{ width: '100%' }}>
                        <div className="card-header-feature">
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <DraggableAreaChart
                                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                properties={this.props.properties}
                                dataChart={dataChart}
                                scale={{ y: (this.props.extraProperties[DALI_DEXAL_SETTINGS.dimmingCurve] && (this.props.extraProperties[DALI_DEXAL_SETTINGS.dimmingCurve].value === '1')) ? "linear" : "log" }}
                                x={{ 'title': t('Time') }}
                                y={{ 'title': t('Output_Level_Percent') }}
                                min={{ y: 0, x: 0 }}
                                max={{ y: 100, x: 4000 }}
                                tickValues={{ x: [], y: [] }}
                                yThresholds={[
                                    { value: this.extractPercentageValue({ value:
                                        this.props.extraProperties[DALI_DEXAL_SETTINGS.maximum] ? this.props.extraProperties[DALI_DEXAL_SETTINGS.maximum].value : 255,
                                    valueMeta: { min: 1, max: 254 } }), color: 'rgb(255,0,0)' },
                                    { value: this.extractPercentageValue({ value:
                                        this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum].value ? this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum].value : 0,
                                    valueMeta: { min: 1, max: 254 } }), color: 'rgb(255,0,0)' },
                                ]}
                                yLabels={this.getYLabels(dataChart)}
                                xLabels={this.getXLabels(dataChart)}
                                sections={{ 0: "area-light", 1: "area-light", 2: "area-dark", 3: "area-light", 4: "area-dark", 5: "area-light", 6: "area-dark", 7: "area-light" }}
                                handleChange={this.handleChartChange} />
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }

    getXLabels(dataChart) {

        const labels = [];
        const smallLabels = [];
        const ticks = [];

        dataChart.forEach((el, index) => {
            switch (el.timeLabel) {
                case 'startTime-0':
                    ticks.push(el.x);
                    labels.push({ label: 'Enter', x: el.x });
                    break;
                case 'fadeUpTime-1':
                    ticks.push(el.x);
                    smallLabels.push({ label: '1', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'holdTime-2':
                    ticks.push(el.x);
                    labels.push({ label: 'Exit', x: el.x });
                    break;
                case 'holdTime-3':
                    ticks.push(el.x);
                    smallLabels.push({ label: '2', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'fadeDownTime-4':
                    ticks.push(el.x);
                    smallLabels.push({ label: '3', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'holdTime-5':
                    ticks.push(el.x);
                    smallLabels.push({ label: '4', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'fadeDownTime-6':
                    ticks.push(el.x);
                    smallLabels.push({ label: '5', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'holdTime-7':
                    ticks.push(el.x);
                    smallLabels.push({ label: '6', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                default:
                    break;
            }
        });

        return { labels: labels, smallLabels: smallLabels, ticks: ticks };
    }

    getYLabels(dataChart) {
        const labels = {};

        //insert zero label
        const zero = Math.round(this.extractPercentageValue({ value: 0, valueMeta: { min: 1, max: 254 } }));
        labels[zero] = { label: '0', y: zero };

        //insert data labels
        dataChart.forEach((el) => {
            const val = Math.round(el.y);
            if (!labels[val]) {
                labels[val] = { label: val.toString(), y: val }
            }
        });

        //insert max label if max value is not present
        const max = Math.round(this.extractPercentageValue({ value:
            this.props.extraProperties[DALI_DEXAL_SETTINGS.maximum] ? this.props.extraProperties[DALI_DEXAL_SETTINGS.maximum].value : 255,
        valueMeta: { min: 1, max: 254 } }));
        if (!labels[max]) {
            labels[max] = { label: 'max', y: max };
        }

        //insert min label if min value is not present
        const min = Math.round(this.extractPercentageValue({ value:
            this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum] ? this.props.extraProperties[DALI_DEXAL_SETTINGS.minimum].value : 0,
        valueMeta: { min: 1, max: 254 } }));
        if (!labels[min]) {
            labels[min] = { label: 'min', y: min };
        }

        return Object.keys(labels).map((key) => { return labels[key]; });
    }

    getDataChart(properties) {

        const dataChart = [];

        if (properties[CORRIDOR.holdTime01].value === "Infinite") {

            dataChart.push({ x: 0, y: 0, section: 0 });

            dataChart.push({
                x: 0,
                y: +this.extractPercentageValue(properties[CORRIDOR.standbyLevel01]),
                timeLabel: "preStartTime-0",
                section: 0
            });
        } else {

            dataChart.push({
                x: 100,
                y: 0,
                section: 0
            });
        }

        dataChart.push({
            x: 100,
            y: +this.extractPercentageValue(properties[CORRIDOR.standbyLevel01]),
            timeLabel: "startTime-0",
            section: 0
        });

        const fadeUpTimeIndex = properties[CORRIDOR.fadeUpTime].valueMeta.availableValues.sort().indexOf(properties[CORRIDOR.fadeUpTime].value);
        dataChart.push({
            x: dataChart[dataChart.length - 1].x + (fadeUpTimeIndex > 0 ? (100 + fadeUpTimeIndex * 25) : 0),
            y: +this.extractPercentageValue(properties[CORRIDOR.operativeLevel]),
            timeLabel: "fadeUpTime-1",
            section: 1
        });

        dataChart.push({
            x: dataChart[dataChart.length - 1].x + 250,
            y: +this.extractPercentageValue(properties[CORRIDOR.operativeLevel]),
            timeLabel: "holdTime-2",
            section: 2
        });

        const holdTime00Index = properties[CORRIDOR.holdTime00].valueMeta.availableValues.indexOf(properties[CORRIDOR.holdTime00].value);
        dataChart.push({
            x: dataChart[dataChart.length - 1].x + (holdTime00Index > 0 ? (holdTime00Index * 1.5) : 0),
            y: +this.extractPercentageValue(properties[CORRIDOR.operativeLevel]),
            timeLabel: "holdTime-3",
            section: 3
        });

        const fadeDownTimeIndex = properties[CORRIDOR.fadeDownTime].valueMeta.availableValues.indexOf(properties[CORRIDOR.fadeDownTime].value);
        dataChart.push({
            x: dataChart[dataChart.length - 1].x + (fadeDownTimeIndex > 0 ? (100 + fadeDownTimeIndex * 25) : 0),
            y: +this.extractPercentageValue(properties[CORRIDOR.standbyLevel01]),
            timeLabel: "fadeDownTime-4",
            section: 4
        });

        if (properties[CORRIDOR.holdTime01].value === "Infinite") {
            dataChart.push({
                x: 4000,
                y: +this.extractPercentageValue(properties[CORRIDOR.standbyLevel01]),
                timeLabel: "holdTime-5",
                section: 5
            });
        } else {

            const holdTime01Index = properties[CORRIDOR.holdTime01].valueMeta.availableValues.indexOf(properties[CORRIDOR.holdTime01].value);
            dataChart.push({
                x: dataChart[dataChart.length - 1].x + (holdTime01Index > 0 ? (holdTime01Index * 1.5) : 0),
                y: +this.extractPercentageValue(properties[CORRIDOR.standbyLevel01]),
                timeLabel: "holdTime-5",
                section: 5
            });

            const fadeDownTime12Index = properties[CORRIDOR.fadeDownTime12].valueMeta.availableValues.sort().indexOf(properties[CORRIDOR.fadeDownTime12].value);
            dataChart.push({
                x: dataChart[dataChart.length - 1].x + (fadeDownTime12Index > 0 ? (100 + fadeDownTime12Index * 25) : 0),
                y: +this.extractPercentageValue(properties[CORRIDOR.standbyLevel02]),
                timeLabel: "fadeDownTime-6",
                section: 6
            });

            const holdTime02Index = properties[CORRIDOR.holdTime02].valueMeta.availableValues.indexOf(properties[CORRIDOR.holdTime02].value);
            dataChart.push({
                x: dataChart[dataChart.length - 1].x + (holdTime02Index > 0 ? (holdTime02Index * 1.5) : 0),
                y: +this.extractPercentageValue(properties[CORRIDOR.standbyLevel02]),
                timeLabel: "holdTime-7",
                section: 7
            });

            dataChart.push({
                x: dataChart[dataChart.length - 1].x,
                y: 0,
                section: 7
            });
        }

        // Setting data for the chart
        // dataChart = dataChart.filter((d) => d.x && d.y && d.x !== "Off" && d.y !== "Off" );

        return dataChart;
    }

    extractPercentageValue(property) {
        if (property.value === 0 || property.value === '0') {
            // Otherwise getPercentage return ""
            return 0;
        }
        return parseFloat(this.getPercentage(property.value, property.valueMeta.min, property.valueMeta.max).replace('≈ ', '').replace(' %', ''));
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Corridor));
